// extracted by mini-css-extract-plugin
module.exports = {"ChatContainer":"_2qrcF6yAkFOvAe8cr0gOr5","GroupChatArea":"_2cEvoSBXWuxYcg1ULtzeCG","WMobileAdjust":"vSpm6W2QQndWTuhAs89nz"};